import { IconBase } from '../IconBase'
import { IconProps } from '../types'

// FileNew01.tsx
export const FileNew01 = (props: IconProps) => {
  return (
    <IconBase {...props}>
      <g transform="scale(1.7142857)">
        <path
          d="M9.33341 2.33398C9.65558 2.33398 9.91675 2.59515 9.91675 2.91732C9.91675 3.23948 9.65558 3.50065 9.33341 3.50065H1.75008C1.42792 3.50065 1.16675 3.23948 1.16675 2.91732C1.16675 2.59515 1.42792 2.33398 1.75008 2.33398H9.33341Z"
          fill="currentColor"
        />
        <path
          d="M6.41675 6.41602C6.73891 6.41602 7.00008 6.67718 7.00008 6.99935C7.00008 7.32152 6.73891 7.58268 6.41675 7.58268H1.75008C1.42792 7.58268 1.16675 7.32152 1.16675 6.99935C1.16675 6.67718 1.42792 6.41602 1.75008 6.41602H6.41675Z"
          fill="currentColor"
        />
        <path
          d="M9.33341 10.5C9.65558 10.5 9.91675 10.7612 9.91675 11.0833C9.91675 11.4055 9.65558 11.6667 9.33341 11.6667H1.75008C1.42792 11.6667 1.16675 11.4055 1.16675 11.0833C1.16675 10.7612 1.42792 10.5 1.75008 10.5H9.33341Z"
          fill="currentColor"
        />
        <path
          d="M9.91675 8.74935V5.24935C9.91675 4.92718 10.1779 4.66602 10.5001 4.66602C10.8222 4.66602 11.0834 4.92718 11.0834 5.24935V8.74935C11.0834 9.07152 10.8222 9.33268 10.5001 9.33268C10.1779 9.33268 9.91675 9.07152 9.91675 8.74935Z"
          fill="currentColor"
        />
        <path
          d="M12.2501 6.41602C12.5722 6.41602 12.8334 6.67718 12.8334 6.99935C12.8334 7.32152 12.5722 7.58268 12.2501 7.58268H8.75008C8.42792 7.58268 8.16675 7.32152 8.16675 6.99935C8.16675 6.67718 8.42792 6.41602 8.75008 6.41602H12.2501Z"
          fill="currentColor"
        />
      </g>
    </IconBase>
  )
}
